import { usersOps } from "../api/operations";
import { ROLE } from "../Auth/useRole";
import { entityFactory } from "../hooks/useEntity";
import { usersToMemberEdit } from "../helpers/utils";
import { defineEntity } from "../api/entity";

const conf = defineEntity({
  ...entityFactory("user"),
  endpoint: "users",
  operations: usersOps,
  roleView: [ROLE.USER_VIEW, ROLE.USER_ADMIN],
  roleAdmin: [ROLE.USER_ADMIN],
  singularName: (t) => t("User"),
  name: (t) => t("Users"),
  infiniteNormalizer: (value) => ({
    rowCount: value.rowCount,
    first: value.first,
    results: usersToMemberEdit(value.results ?? []),
  }),
  sendCulture: true,
  dependencies: ["contract", "profile"],
  syncCustomerFilter: true,
});

export default conf;
